import React from 'react';

// Usage: <SubscriptionBadgeCircle planType="gold" />
// Expects logo files: abo_bronze.png, abo_silver.png, abo_gold.png, abo_enterprise.png

const badgeMap = {
  bronze: 'abo_bronze.png',
  silver: 'abo_silver.png',
  gold: 'abo_gold.png',
  enterprise: 'abo_enterprise.png',
};

// Couleurs de fond douces pour chaque plan
const bgMap = {
  bronze: '#f7e3c2', // bronze pâle
  silver: '#e6e8ec', // silver pâle
  gold: '#fff7c2',   // gold pâle
  enterprise: '#ede6fa', // violet pâle
};

function SubscriptionBadgeCircle({ planType = 'bronze', size = 48 }) {
  const logo = badgeMap[planType] || badgeMap['bronze'];
  const bgColor = bgMap[planType] || '#fff';
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bgColor,
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #eee',
      }}
    >
      <img
        src={process.env.PUBLIC_URL ? process.env.PUBLIC_URL + '/' + logo : logo}
        alt={planType + ' abonnement'}
        style={{ width: size * 0.7, height: size * 0.7, objectFit: 'contain' }}
      />
    </div>
  );
}

export default SubscriptionBadgeCircle; 